// extracted by mini-css-extract-plugin
export default {"inputBox":"FloatingInput_inputBox__v3ZKJ","input":"FloatingInput_input__zjE1u","error":"FloatingInput_error__wXBoK","inputIcons":"FloatingInput_inputIcons__Gw1hf"};